import React, { useEffect } from 'react';

import AnalyticsWebClient from '@atlassiansox/analytics-web-client';

import { cssMap, cx } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

interface PreviewPanelBodyProps {
	children: React.ReactNode;
	parentProduct?: string;
	panelType?: string;
	analyticsClient?: AnalyticsWebClient | undefined | null;
	withPadding?: boolean;
}

const styles = cssMap({
	wrapper: {
		flexGrow: 1,
		overflowY: 'auto',
	},
	padding: {
		paddingInlineStart: token('space.300'),
		paddingInlineEnd: token('space.300'),
		paddingBlockStart: token('space.200'),
		paddingBlockEnd: token('space.200'),
	},
});

export const PreviewPanelBody = ({
	children,
	analyticsClient,
	parentProduct,
	panelType,
	withPadding = true,
}: PreviewPanelBodyProps) => {
	useEffect(() => {
		if (analyticsClient) {
			analyticsClient.sendTrackEvent({
				action: 'viewed',
				actionSubject: 'preview-panel',
				actionSubjectId: 'preview-panel-view',
				source: 'preview-panel',
				attributes: {
					parentProduct,
					panelType,
				},
			});
		}
	}, [analyticsClient, parentProduct, panelType]);

	return <Flex xcss={cx(styles.wrapper, withPadding && styles.padding)}>{children}</Flex>;
};
